'use strict';


import ErrorBoundary from '../shared/ErrorBoundary';
import Form from './components/Form';

const container = document.getElementById('boxes-form-holder');
const root = ReactDOM.createRoot(container);

window.createBoxesForm = (type, present = false) => {	
	root.render(<ErrorBoundary><Form type={ type } present={ present } /></ErrorBoundary>);
}
